import type { StateCreator } from 'zustand';

export interface DriversTourSliceState {
  progressBar: boolean;
  progressBarTitle: string;
  onboardingStepName: string;
  progressBarTourStepsTotal: number;
  driversInitialTour: boolean;
  driversTourModal: boolean;
  driversTour: boolean;
  driversDrawerTour: boolean;
  setDriversInitialTour: (value: boolean) => void;
  setDriversTourModal: (value: boolean) => void;
  setDriversTour: (value: boolean) => void;
  setDriversDrawerTour: (value: boolean) => void;
  setDriversTourStart: () => void;
  setDriversTourFinish: () => void;
}

type StateCreatorDriversTour = StateCreator<DriversTourSliceState>;

const initialStates = {
  progressBar: false,
  progressBarTitle: 'Adicione motoristas no painel',
  onboardingStepName: '',
  progressBarTourStepsTotal: 0,
  driversInitialTour: false,
  driversTour: false,
  driversDrawerTour: false,
  driversTourModal: false,
};

const createDriversTourSlice: StateCreatorDriversTour = (set) => ({
  ...initialStates,
  setDriversInitialTour: (driversInitialTour: boolean) => set({ driversInitialTour }),
  setDriversTourModal: (driversTourModal: boolean) => set({ driversTourModal }),
  setDriversTour: (driversTour: boolean) => set({ driversTour }),
  setDriversDrawerTour: (driversDrawerTour: boolean) => set({ driversDrawerTour }),
  setDriversTourStart: () =>
    set({
      ...initialStates,
      progressBar: true,
      onboardingStepName: 'Drivers',
      progressBarTourStepsTotal: 3,
      driversInitialTour: true,
    }),
  setDriversTourFinish: () =>
    set({
      ...initialStates,
      progressBar: true,
    }),
});

export default createDriversTourSlice;
